const baseURl = "https://sentiment.aurodigital.ai/api/v1/";
const pricePredictionBaseUrl="https://price-prediction.aurodigital.ai/";
// const baseURl = "http://44.240.12.174:8001/api/v1/";
// data/newsletter_positive_sentiment_data
export const getInsights = async () => {
  const response = await fetch(`${baseURl}data/sentiment_insights`).then((response) => response.json());
  return response;
};

export const getCoinVelocity = async () => {
  const response = await fetch(`${baseURl}data/coin_wise_social_velocity`).then((response) => response.json());
  // console.log(response);
  return response;
};

export const getCardVelocity = async () => {
  const response = await fetch(`${baseURl}data/cards_social_velocity`).then((response) => response.json());
  // console.log(response);
  return response;
};

export const getPositiveSentiment = async () => {
  const response = await fetch(`${baseURl}data/positive_sentiment_data`).then((response) => response.json());
  // console.log(response);
  return response;
};

export const getNegativeSentiment = async () => {
  const response = await fetch(`${baseURl}data/negative_sentiment_data`).then((response) => response.json());
  // console.log(response);
  return response;
};

export const getCoinChannelWise = async () => {
  const response = await fetch(`${baseURl}data/coin_channel_wise_data`).then((response) => response.json());
  return response;
};

export const getNegative_sentiment_curated = async () => {
  const response = await fetch(`${baseURl}data/newsletter_negative_sentiment_data`).then((response) => response.json());
  return response;
};

export const getPositive_sentiment_curated = async () => {
  const response = await fetch(`${baseURl}data/newsletter_positive_sentiment_data`).then((response) => response.json());

  // console.log("in eee", response);
  return response;
};

export const history_curated = async (params) => {
  const response = await fetch(`${baseURl}data/historical_newsletter_data`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => response.json());

  // console.log("in eee", response);
  return response;
};

export const history_ai = async (params,pageNum=1) => {
  const response = await fetch(`${baseURl}data/historical_sentiment_paginated?page_num=${pageNum}&limit=20`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => response.json());

  return response;
};

// export const getIcon = async (symbol) => {
//   const response = await fetch(`https://sentiment.aurodigital.ai/api/v1/data/crypto_info?symbol=${symbol}`).then((response) => response.json());
//   return response;
// };


export const coin_velocity_sentiment_data = async (coinName) => {

  let params = { "coin_name": coinName };
  const response = await fetch(`${baseURl}data/coin_sentiment_data`, {

    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => response.json());

  // console.log("in eee", response);
  return response;
};

export const crypto_logo = async (coinArray) => {
  let uniqCoinList = [...new Set(coinArray)];
  let params = { "coinlist": uniqCoinList.join() };
  const response = await fetch(`${baseURl}data/crypto_logo_info`, {

    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => response.json());

  // console.log("in eee", response);
  return response;
};

export const get_events = async () => {
  const response = await fetch('https://ims.aurodigital.ai/api/research-upload/event/').then((response) => response.json());
  return response;
};


export const get_research = async () => {
  const response = await fetch('https://ims.aurodigital.ai/api/research-upload/data/').then((response) => response.json());
  return response;
};

export const priceSentimentLineChartData = async (coin) => {
  let params = { "pair": `${coin}USDT` };

  const response = await fetch(`${baseURl}data/price_sentiment_line_chart`, {

    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => response.json());

  // console.log("in eee", response);
  return response;
};

export const pricePrediction = async (model) => {
  let params = {};

  const response = await fetch(`${pricePredictionBaseUrl}predict-all-${model}`, {

    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => response.json());

  // console.log("in eee", response);
  return response;
};